const resources = {
    pageTitle: 'Allow Access to your Beauty Insider account',
    whatCanDo: 'What ChatGPT can help you do',
    permission1: 'Recommend products you\'ll love',
    permission2: 'Find and re-shop favorites faster',
    permission3: 'Discover brands and routines that fit you',
    permission4: 'Access and update your Sephora shopping cart',
    allowAccessButton: 'Allow Access',
    cancelButton: 'Cancel',
    manageAccessText: 'Review or remove access anytime in your ChatGPT settings by disconnecting the Sephora app.',
    privacyPrefix: 'For details on how ChatGPT uses your data, see the',
    chatGPTPrivacyPolicy: 'ChatGPT Privacy Policy',
    privacyMiddle: '. For how Sephora protects your information, see the',
    sephoraPrivacyPolicy: 'Sephora Privacy Policy',
    privacyEnd: '.',
    sessionIdNotFound: 'Session ID not found. Please restart the authorization flow.',
    authorizationFailed: 'Authorization failed. Please try again.',
    pageTitleGuest: 'Use ChatGPT with Sephora',
    permissionGuest1: 'Explore products and brands',
    permissionGuest2: 'Compare options and get recommendations',
    permissionGuest3: 'Discover routines, tips, and inspiration',
    personalizedHeader: 'Want a more personalized experience?',
    personalizedText: 'Connect your Beauty Insider account to tailor results to what you like and buy.',
    continueButton: 'Continue as a Guest',
    backButtonAriaLabel: 'Back'
};

export default function getResource(label) {
    return resources[label];
}
